export const ORGANIZATION = 'organization';
export const INDIVIDUAL = 'individual';

export const ALL_TYPES = [
  ORGANIZATION,
  INDIVIDUAL
];

export const isOrgAccount = account => account?.type === ORGANIZATION;
